import { useNavigate, useParams } from "react-router";
import { useGetPublicCourseDetailsQuery } from "../../../app/features/courses/courses.api";
import DetailsOverview from "../../../components/ui/course-details/DetailsOverview";
import CourseDetailsHeader from "../../../components/ui/course-details/Header";
import useError from "../../../hooks/useError";
import Navbar from "../../../layouts/web/_components/navbar";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "কোর্সসমূহ",
    path: "/user/courses",
  },
  {
    title: "বিস্তারিত",
  },
];

export default function UserCourseDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isLoading, error } = useGetPublicCourseDetailsQuery(
    id as string,
    {
      skip: !id,
    },
  );
  useError(error, "কোর্স লোড করা যায়নি");

  return (
    <main>
      <Navbar />
      <CourseDetailsHeader
        breadcrumb={breadcrumb}
        isLoading={isLoading}
        course={data}
      />
      <DetailsOverview
        isLoading={isLoading}
        course={data}
        onMoreButton={() =>
          navigate(
            `/user/courses/${id}/module?title=${encodeURIComponent(data?.title || "")}`,
          )
        }
      />
    </main>
  );
}
